import React, { Fragment, Suspense } from "react";
import { Route, Switch } from "react-router-dom";
import LoadingScreen from "../LoadingScreen";
export default function RenderRoutes({ routes, FallbackLayoutComponent, }) {
    const FallBackLayout = FallbackLayoutComponent || Fragment;
    return (React.createElement(Suspense, { fallback: React.createElement(FallBackLayout, null,
            React.createElement(LoadingScreen, null)) },
        React.createElement(Switch, null, routes.map((route) => {
            const { layout, component, path, exact } = route;
            const Layout = layout || Fragment;
            const Component = component;
            return (React.createElement(Route, { key: path, path: path, exact: exact, render: (routeProps) => (React.createElement(Layout, null,
                    React.createElement(Component, { ...routeProps }))) }));
        }))));
}
RenderRoutes.defaultProps = {
    FallbackLayoutComponent: null,
};
//# sourceMappingURL=index.js.map